import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "13",
  fill: "none",
  viewBox: "0 0 13 13"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#696986",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M6.121 11.708c.12.07.18.105.265.123a.6.6 0 0 0 .227 0c.085-.018.145-.053.264-.123 1.056-.616 3.956-2.55 3.956-5.208V4.442c0-.582 0-.873-.09-1.08a.95.95 0 0 0-.369-.453c-.184-.13-.544-.205-1.265-.354a4.6 4.6 0 0 1-1.963-.896c-.267-.207-.401-.31-.506-.338a.46.46 0 0 0-.282 0c-.104.028-.238.131-.506.338a4.6 4.6 0 0 1-1.962.896c-.721.15-1.082.224-1.265.354a.95.95 0 0 0-.37.454c-.089.206-.089.497-.089 1.079V6.5c0 2.659 2.9 4.592 3.955 5.208"
    }, null, -1)
  ]))]))
}
export default { render: render }